// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
import { ErrorStateMatcher } from '@angular/material/core';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';

export class BothEmptyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    if (!control) {
      return false;
    }

    const touchedOrDirty = control.touched || control.dirty;
    if (!touchedOrDirty) {
      return false;
    }

    const group = control.parent;

    const hasBothEmpty =
      !!group && group.hasError('bothEmpty');

    const hasOwnError =
      control.invalid;

    return hasBothEmpty || hasOwnError;
  }
}